export default __webpack_public_path__ + "static/media/banner-finder-medication-tablet.2f9c92b2.svg";